var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedininline = function SvgLinkedininline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2A67BC",
    d: "M4.625 4.067a2.943 2.943 0 0 1 5.884 0c0 1.624-1.318 2.97-2.942 2.97S4.625 5.69 4.625 4.067M29.119 25.625v-.001h.006v-8.985c0-4.396-.946-7.782-6.085-7.782-2.47 0-4.128 1.356-4.805 2.64h-.072v-2.23h-4.872v16.357h5.073v-8.1c0-2.132.405-4.194 3.046-4.194 2.602 0 2.64 2.434 2.64 4.332v7.963h5.069M5.03 9.268h5.079v16.357h-5.08V9.268"
  })));
};
export default SvgLinkedininline;